import { httpErrorHandler } from '../../common/functions/helpers';
import { fetchAddresses, validateCustomerReferenceNumber } from './customerService';

export const CUSTOMER_ACTIONS = {
  UPDATE_ENROLLMENT_CHECK: 'CUSTOMER_ACTIONS.UPDATE_ENROLLMENT_CHECK',
  UPDATE_LOADING: 'CUSTOMER_ACTIONS.UPDATE_LOADING',
  UPDATE_LOOKUP_FIELDS: 'CUSTOMER_ACTIONS.UPDATE_LOOKUP_FIELDS',
  UPDATE_ADDRESSES: 'CUSTOMER_ACTIONS.UPDATE_ADDRESSES',
  UPDATE_ADDRESS_DETAIL: 'CUSTOMER_ACTIONS.UPDATE_ADDRESS_DETAIL',
  UPDATE_SELECTED_ADDRESS_REFERENCE: 'CUSTOMER_ACTIONS.UPDATE_SELECTED_ADDRESS_REFERENCE',
  UPDATE_IS_MANUAL_ADDRESS: 'CUSTOMER_ACTIONS.UPDATE_IS_MANUAL_ADDRESS',
  UPDATE_MANUAL_ADDRESS: 'CUSTOMER_ACTIONS.UPDATE_MANUAL_ADDRESS',
  UPDATE_CUSTOMER_CONTACT_DETAILS: 'CUSTOMER_ACTIONS.UPDATE_CUSTOMER_CONTACT_DETAILS',
  UPDATE_REPRESENTATIVE_CONTACT_DETAILS: 'CUSTOMER_ACTIONS.UPDATE_REPRESENTATIVE_CONTACT_DETAILS',
  UPDATE_ACCOUNT_REFERENCE: 'CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE',
  UPDATE_ACCOUNT_REFERENCE_POSTCODE: 'CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_POSTCODE',
  UPDATE_ACCOUNT_REFERENCE_NOT_KNOWN: 'CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_NOT_KNOWN',
  RESET: 'CUSTOMER_ACTIONS.RESET',
};

export const updateEnrollmentCheck = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ENROLLMENT_CHECK,
  payload: value,
});

export const updateLoading = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_LOADING,
  payload: value,
});

export const updateLokupFields = (values) => ({
  type: CUSTOMER_ACTIONS.UPDATE_LOOKUP_FIELDS,
  payload: values,
});

export const updateAddresses = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ADDRESSES,
  payload: value,
});

export const updateAddressDetail = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ADDRESS_DETAIL,
  payload: value,
});

export const updateSelectedAddressReference = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_SELECTED_ADDRESS_REFERENCE,
  payload: value,
});

export const updateIsManualAddress = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_IS_MANUAL_ADDRESS,
  payload: value,
});

export const updateManualAddress = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_MANUAL_ADDRESS,
  payload: value,
});

export const updateCustomerContactDetails = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_CUSTOMER_CONTACT_DETAILS,
  payload: value,
});

export const updateRepresentativeContactDetails = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_REPRESENTATIVE_CONTACT_DETAILS,
  payload: value,
});

export const updateAccountReference = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE,
  payload: value,
});

export const updateAccountReferencePostcode = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_POSTCODE,
  payload: value,
});

export const updateAccountReferenceNotKnown = (value) => ({
  type: CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_NOT_KNOWN,
  payload: value,
});

export const resetCustomer = () => ({
  type: CUSTOMER_ACTIONS.RESET,
});

export const validateCustomerReferenceNumberAndPostcode = (params, responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response);
  };

  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const response = await validateCustomerReferenceNumber(params);
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(error);
  }
};

export const getAddressesByPostcode = (params, responseCallback, errorCallback) => async () => {
  const successHandler = (response) => {
    responseCallback(response);
  };

  const errorHandler = (error) => {
    errorCallback(error);
  };

  try {
    const response = await fetchAddresses(params.postcode, params.buildingNumber);
    response ? successHandler(response) : errorHandler(response.status);
  } catch (error) {
    errorHandler(httpErrorHandler(error));
  }
};
